import VueWrapper from '@/components/core/Vue/vue.wrapper';
import {CAP_DIRECTION} from '@/globals';
import {CreateEditEquipmentCapViewModel, EquipmentCapModel} from '@/sdk';
import {EquipmentCapsApi} from '@/sdk/api-services';
import {Component, Prop, Watch} from 'vue-property-decorator';

@Component({
    name: 'CapsDetailsForm',
})
export default class CapsDetailsFormComponent extends VueWrapper {
    @Prop({type: Object, default: null})
    private selectedCap!: EquipmentCapModel | null;

    @Prop({type: String, default: null})
    private locationId!: string | null;

    @Prop({type: Boolean, default: false})
    public readonly readonly!: boolean;

    public capForm: CreateEditEquipmentCapViewModel = {
        id: '',
        title: '',
        capDirection: CAP_DIRECTION.IN,
        sortOrder: 0,
        modelNo: '',
        certificationNo: '',
        manufacturer: '',
        serialNo: '',
        protectionType: [],
        cableEntryType: '',
    };

    public isLoading: boolean = false;

    public capDirections = [
        {key: CAP_DIRECTION.IN, value: 'Incoming'},
        {key: CAP_DIRECTION.OUT, value: 'Outgoing'},
    ];

    public cableEntryTypes = [
        {key: 'Cable gland', value: 'Cable gland'},
        {key: 'Conduit', value: 'Conduit'},
        {key: 'Connector', value: 'Connector'},
        {key: 'Receptacle', value: 'Receptacle'},
        {key: 'Plug', value: 'Plug'},
        {key: 'Socket', value: 'Socket'},
        {key: 'Adaptor', value: 'Adaptor'},
        {key: 'Reducer', value: 'Reducer'},
        {key: 'Blanking Element', value: 'Blanking Element'},
        {key: 'Direct Input', value: 'Direct Input'},
    ];

    public protectionTypes = [
        {key: 'Ex d', value: 'Ex d'},
        {key: 'Ex e', value: 'Ex e'},
        {key: 'Ex n', value: 'Ex n'},
        {key: 'Ex t', value: 'Ex t'},
        {key: 'NO', value: 'NO'},
    ];

    get isEditing(): boolean {
        return !!this.capForm.id;
    }

    @Watch('selectedCap', {immediate: true})
    private onSelectedCapChanged(newCap: EquipmentCapModel | null): void {
        if (newCap) {
            this.loadCapData(newCap);
        } else {
            this.resetForm();
        }
    }

    @Watch('locationId', {immediate: true})
    private onLocationIdChanged(newLocationId: string | null): void {
        // Location ID is handled in form operations
    }

    private loadCapData(cap: EquipmentCapModel): void {
        this.capForm = {
            id: cap.id || '',
            title: cap.title || '',
            capDirection: cap.capDirection || CAP_DIRECTION.IN,
            sortOrder: cap.sortOrder || 0,
            modelNo: cap.modelNo || '',
            certificationNo: cap.certificationNo || '',
            manufacturer: cap.manufacturer || '',
            serialNo: cap.serialNo || '',
            protectionType: cap.protectionType || [],
            cableEntryType: cap.cableEntryType || '',
        };
    }

    public async saveCap(): Promise<void> {
        if (!this.locationId) {
            console.error('Location ID is required');
            return;
        }

        this.isLoading = true;

        try {
            const equipmentCapsApi = new EquipmentCapsApi();

            if (this.isEditing && this.capForm.id) {
                const updatedCap = await equipmentCapsApi.updateCap(this.locationId, this.capForm.id, this.capForm);
                // Get the updated cap data
                // const updatedCap = await equipmentCapsApi.getCapById(this.capForm.id);
                this.onCapUpdated(updatedCap);
            } else {
                const caps = await equipmentCapsApi.createCapsMultiple(this.locationId, 0, [this.capForm]);
                const result = caps[0];
                this.onCapCreated(result);
            }

            // Show success message - using console for now
            console.log(this.isEditing ? 'Cap updated successfully!' : 'Cap created successfully!');
        } catch (error) {
            console.error('Error saving cap:', error);
            this.AlertSrv.show('error', 'Failed to save cap. Please try again.');
        } finally {
            this.isLoading = false;
        }
    }

    public resetForm(): void {
        this.capForm = {
            id: '',
            title: '',
            capDirection: CAP_DIRECTION.IN,
            sortOrder: 0,
            modelNo: '',
            certificationNo: '',
            manufacturer: '',
            serialNo: '',
            protectionType: [],
            cableEntryType: '',
        };

        // Reset form validation
        if (this.$refs.capFormRef) {
            (this.$refs.capFormRef as any).resetValidation();
        }

        this.onFormReset();
    }

    private onCapCreated(cap: EquipmentCapModel) {
        //
    }

    private onCapUpdated(cap: EquipmentCapModel) {
        this.AlertSrv.show('success', 'Cap updated successfully!');
        this.$emit('cap-updated', cap);
    }

    private onFormReset(): void {
        // Event emitted when form is reset
        this.$emit('form-reset');
    }
}
